export const findSecondaryIndexInHead = (
  head: string[],
  dollars: string
): number => {
  const dollarsLength = dollars.length;
  return head.findIndex(cell => cell.lastIndexOf("$") === dollarsLength - 1);
};

export const createCharTimes = (char: string, times: number) => {
  let str = "";
  for (let i = 0; i < times; i++) {
    str += char;
  }
  return str;
};

export const characterCountInString = (char: string, str: string) => {
  let sum = 0;

  for (let i = 0; i < str.length; i++) {
    if (str[i] === char) {
      sum++;
    }
  }

  return sum;
};
